import { Flex, Statistic } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ShrinkingButton, StatCard } from "~/components";
import { COLORS } from "~/utils";

export type HomeActionStatCardProps = {
  title: string;
  description: string;
  count: number;
  detailsPath: string;
  verySmallScreen: boolean;
  warning?: boolean;
};

export const HomeActionStatCard = ({
  title,
  description,
  count,
  detailsPath,
  verySmallScreen,
  warning = false,
}: HomeActionStatCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showWarning = warning && count > 0;

  return (
    <StatCard
      title={title}
      description={description}
      style={
        showWarning
          ? {
              borderColor: COLORS.warm_tangerine,
              boxShadow: `0 0 0 1px ${COLORS.warm_tangerine}22`,
            }
          : undefined
      }
    >
      <Flex style={{ flexWrap: "wrap", alignItems: "flex-end", gap: 8 }}>
        <Statistic
          value={count}
          valueStyle={
            showWarning
              ? { color: COLORS.warm_tangerine }
              : { color: COLORS.baby_blue }
          }
        />
        <ShrinkingButton
          small={verySmallScreen}
          onClick={() => navigate(detailsPath)}
          type="primary"
          style={{ marginLeft: "auto" }}
        >
          {t("Details")}
        </ShrinkingButton>
      </Flex>
    </StatCard>
  );
};
